import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserVerificationDataAccessModule } from '@fantaz/user-verification/data-access';
import { UserVerificationUiEditInfoDialogModule } from '@fantaz/user-verification/ui/edit-info-dialog';
import { CreditCardRegisterDialogComponent } from '@fantaz/user-verification/ui/register-credit-card-dialog';
import { VerificationDialogComponent } from '@fantaz/user-verification/ui/verification-dialog';
import {
  AttemptsExceededComponent,
  UserVerificationUiVerificationFailuresModule,
} from '@fantaz/user-verification/ui/verification-failures';
import { UserVerificationUiVerificationSuccessDialogModule } from '@fantaz/user-verification/ui/verification-success-dialog';

@NgModule({
  imports: [
    UserVerificationDataAccessModule,
    UserVerificationUiVerificationSuccessDialogModule,
    VerificationDialogComponent,
    CreditCardRegisterDialogComponent,
    UserVerificationUiEditInfoDialogModule,
    UserVerificationUiVerificationFailuresModule,
    AttemptsExceededComponent,
    RouterModule.forChild([
      {
        path: 'verify-user-account',
        redirectTo: '/user-game-profile',
      },
    ]),
  ],
  exports: [UserVerificationDataAccessModule],
})
export class UserVerificationFeaturesShellModule {}
